import TemplatesAddPage from 'categories/simulation/pages/templates-add/templates-add.page';
import federatedFacade from '../federated-bootstrap';

export default federatedFacade(TemplatesAddPage);
